module.exports = __webpack_public_path__ + "static/media/notification-unread-icon.698548cf.png";